import {computed as $hgUW1$computed, reactive as $hgUW1$reactive, getCurrentInstance as $hgUW1$getCurrentInstance, unref as $hgUW1$unref, ref as $hgUW1$ref, onMounted as $hgUW1$onMounted} from "vue";
import $hgUW1$oddform_object from "odd-form_object";
import $hgUW1$i18njs from "i18n-js";
import $hgUW1$moment from "moment";
import $hgUW1$localforage from "localforage";
import {ModalProgrammatic as $hgUW1$ModalProgrammatic, ToastProgrammatic as $hgUW1$ToastProgrammatic} from "buefy";
import $hgUW1$oddmoney from "odd-money";
import {swiper as $ab5e68299c1c624d$re_export$swiper, swiperSlide as $ab5e68299c1c624d$re_export$swiperSlide} from "vue-awesome-swiper";


const $194437a6ef3c58bb$export$f4a5c5dcfe1bba82 = ()=>{
    const instance = (0, $hgUW1$getCurrentInstance)();
    if (!instance) throw "only works in vue component setup function or lifecycle hooks";
    return instance.proxy;
};
var $194437a6ef3c58bb$export$2e2bcd8739ae039 = $194437a6ef3c58bb$export$f4a5c5dcfe1bba82;



const $5c0dceef35680c1f$export$26cbf8c37e721e67 = "store";
const $5c0dceef35680c1f$export$6ccbb43953eebf8 = ()=>{
    const instance = (0, $194437a6ef3c58bb$export$2e2bcd8739ae039)();
    return (0, $hgUW1$reactive)(instance.$store);
};
var $5c0dceef35680c1f$export$2e2bcd8739ae039 = $5c0dceef35680c1f$export$6ccbb43953eebf8;



const $b63295f3629e158d$export$5e0d2110ca6f99be = ()=>{
    const store = (0, $5c0dceef35680c1f$export$2e2bcd8739ae039)();
    const currencyReferenceConfig = (0, $hgUW1$computed)(()=>store.getters["users/currencyReferenceConfig"]);
    return {
        currencyReferenceConfig: currencyReferenceConfig,
        currentCurrency: (0, $hgUW1$computed)(()=>currencyReferenceConfig.value?.selectedCurrency || "TWD")
    };
};
var $b63295f3629e158d$export$2e2bcd8739ae039 = $b63295f3629e158d$export$5e0d2110ca6f99be;




const $86bbc49c94835efd$var$SignedInScopeTypeMap = {
    user: "User",
    admin: "Admin",
    promoter_member: "PromoterMember"
};
const $86bbc49c94835efd$export$3901076af3749fa9 = (envScope = "user")=>{
    const store = (0, $5c0dceef35680c1f$export$2e2bcd8739ae039)();
    const currentUser = (0, $hgUW1$computed)(()=>store.getters["currentUser"]);
    return {
        currentUser: currentUser,
        isUserSignedIn: (0, $hgUW1$computed)(()=>currentUser.value.type === $86bbc49c94835efd$var$SignedInScopeTypeMap[envScope])
    };
};
var $86bbc49c94835efd$export$2e2bcd8739ae039 = $86bbc49c94835efd$export$3901076af3749fa9;




const $66800b516f8df6ed$var$defaultOptions = {
    attributes: {},
    form: (0, $hgUW1$oddform_object)
};
const $66800b516f8df6ed$export$87c0cf8eb5a167e0 = (model, options = {})=>{
    const { attributes: attributes , form: form  } = Object.assign({}, $66800b516f8df6ed$var$defaultOptions, options);
    const formInstance = new form(new model(attributes));
    return (0, $hgUW1$reactive)(formInstance);
};
var $66800b516f8df6ed$export$2e2bcd8739ae039 = $66800b516f8df6ed$export$87c0cf8eb5a167e0;




const $878625f9e2aa6919$export$3f3caade1c12f8c9 = ()=>{
    return {
        /**
     * 取得 Rails model attributes 的 i18n 值
     *
     * @param {string} model model name
     * @param {string} attribute attribute name
     * @param {Object} options assign locals
     * @returns {any}
     */ attributeLocaleText (model, attribute, options = {}) {
            return (0, $hgUW1$i18njs).t(`activerecord.attributes.${model}.${attribute}`, options);
        },
        /**
     * 取得 Rails model name 的 i18n 值
     *
     * @param {string} model model name
     * @param {boolean} isPlural 是否為複數（預設為 false）
     * @returns {string}
     */ modelNameLocaleText (model, isPlural = false) {
            if (isPlural) return (0, $hgUW1$i18njs).t(`activerecord.models.${model}.others`);
            else return (0, $hgUW1$i18njs).t(`activerecord.models.${model}.one`);
        },
        /**
     * 取得 Rails model 中 enums 的 i18n 值
     *
     * @param {string} model model name
     * @param {string} enumAttribute enum 欄位的名稱
     * @param {string} key enum 值的名稱
     * @param {Object} options assign locals
     * @returns {string}
     */ enumLocaleText (model, enumAttribute, key, options = {}) {
            return (0, $hgUW1$i18njs).t(`enums.${model}.${enumAttribute}.${key}`, options);
        },
        /**
     * 取得 Rails model 中 aasm state 的 i18n 值
     *
     * @param {string} model model name
     * @param {string} aasmAttribute 狀態的名稱
     * @param {string} state 狀態值的名稱
     * @returns {string}
     */ aasmStateLocaleText (model, aasmAttribute, state) {
            return (0, $hgUW1$i18njs).t(`aasm_state.${model}.${aasmAttribute}.${state}`);
        },
        /**
     * 取得 Rails model 中 public activity 的 i18n 值
     *
     * @param {string} model model name
     * @param {string} activity 活動的名稱
     * @param {Object} options 若需要可帶入 locals 物件
     * @returns {string}
     */ activityLocaleText (model, activity, options = {}) {
            return (0, $hgUW1$i18njs).t(`activity.${model}.${activity}`, options);
        },
        /**
     * 取得頁面標題的 i18n 值
     *
     * @param {string} scope 頁面操作角色（admin, client 等）
     * @param {string} pageName 頁面名稱
     * @param {string} subPageName 副頁面名稱
     * @returns {string}
     */ pageTitleLocaleText (scope, pageName, subPageName) {
            return (0, $hgUW1$i18njs).t(`page_titles.${scope}.${pageName}.${subPageName}`);
        },
        /**
     * 取得 action 的 i18n 值
     *
     * @param {string} action 動作的名稱
     * @param {Object} locals assign locals
     * @returns {string}
     */ actionLocaleText (action, locals = {}) {
            return (0, $hgUW1$i18njs).t(`actions.${action}`, locals);
        },
        /**
     * 取得 TimeAgo 相對時間的 i18n 值
     *
     * @param {number|Date} datetime
     * @returns {string}
     */ timeAgoLocaleText (datetime) {
            if (datetime instanceof Date) return (0, $hgUW1$moment)(datetime).fromNow();
            else return (0, $hgUW1$moment)(datetime, "X").fromNow();
        },
        /**
     * 取得自訂格式的時間字串
     *
     * @param {number|Date} datetime
     * @param {String} format
     * @returns {string}
     */ dateTimeLocaleText (datetime, format = "YYYY MMMDo HH:mm:ss") {
            if (!datetime) return "-";
            if (datetime instanceof Date) return (0, $hgUW1$moment)(datetime).format(format);
            else return (0, $hgUW1$moment)(datetime, "X").format(format);
        },
        /**
     * 取得 message 的 i18n 值
     *
     * @param {string} message
     * @param {string} locals 可傳入變數
     * @returns {string}
     */ messageLocaleText (message, locals = {}) {
            return (0, $hgUW1$i18njs).t(`messages.${message}`, locals);
        },
        /**
     * 取得 copies 的 i18n 值
     *
     * @param {string} copy
     * @param {string} locals 可傳入變數
     * @returns {string}
     */ copyLocaleText (message, locals = {}) {
            return (0, $hgUW1$i18njs).t(`copies.${message}`, locals);
        },
        systemLocaleText (message, locals = {}) {
            return (0, $hgUW1$i18njs).t(`systems.${message}`, locals);
        },
        localeTextFor (scope, locals = {}) {
            return (0, $hgUW1$i18njs).t(scope, locals);
        }
    };
};
var $878625f9e2aa6919$export$2e2bcd8739ae039 = $878625f9e2aa6919$export$3f3caade1c12f8c9;




const $e769739f1cb29117$export$c28d9e613ce8016a = ()=>{
    return {
        getItem: async (key)=>await (0, $hgUW1$localforage).getItem(key),
        setItem: async (key, value)=>await (0, $hgUW1$localforage).setItem(key, value),
        removeItem: async (key)=>await (0, $hgUW1$localforage).removeItem(key),
        clearStorage: async ()=>await (0, $hgUW1$localforage).clear(),
        storageLength: async ()=>await (0, $hgUW1$localforage).length(),
        storageKeys: async ()=>await (0, $hgUW1$localforage).keys()
    };
};
var $e769739f1cb29117$export$2e2bcd8739ae039 = $e769739f1cb29117$export$c28d9e613ce8016a;



const $b5948fd5da0efdf8$export$33ffd74ebf07f060 = (userParams)=>{
    const params = Object.assign({}, userParams);
    (0, $hgUW1$ModalProgrammatic).open(params);
};
var $b5948fd5da0efdf8$export$2e2bcd8739ae039 = $b5948fd5da0efdf8$export$33ffd74ebf07f060;




const $048803914cb95fb8$var$openModal = (params)=>{
    (0, $hgUW1$ModalProgrammatic).open(params);
};
const $048803914cb95fb8$export$128d2c11f5a1e7f3 = (userParams)=>{
    const defaultParams = {
        parent: (0, $194437a6ef3c58bb$export$f4a5c5dcfe1bba82)()
    };
    const params = Object.assign({}, defaultParams, userParams);
    return ()=>$048803914cb95fb8$var$openModal(params);
};
var $048803914cb95fb8$export$2e2bcd8739ae039 = $048803914cb95fb8$export$128d2c11f5a1e7f3;





const $ce0348ab86c375ce$var$defaultCustomCurrencies = {
    TWD: {
        iso_code: "TWD",
        name: "New Taiwan Dollar",
        symbol: "$",
        disambiguate_symbol: "NT$",
        subunit: "Cent",
        subunit_to_unit: 100,
        symbol_first: true,
        smallest_denomination: 100
    }
};
const $ce0348ab86c375ce$export$549663b327b2b282 = (customCurrencies = $ce0348ab86c375ce$var$defaultCustomCurrencies)=>{
    const { currentCurrency: currentCurrency , currencyReferenceConfig: currencyReferenceConfig  } = (0, $b63295f3629e158d$export$2e2bcd8739ae039)();
    return {
        toMoney: (cents, options = {
            isExchange: true,
            currency: currentCurrency,
            customCurrencies: undefined
        })=>{
            if ((0, $hgUW1$unref)(options.currency) === "TWD" || !options.isExchange) return new (0, $hgUW1$oddmoney)(cents, "TWD", options.customCurrencies);
            cents = Math.round(cents * (0, $hgUW1$unref)(currencyReferenceConfig).currencyRate / 100) * 100;
            return new (0, $hgUW1$oddmoney)(cents, (0, $hgUW1$unref)(options.currency), options.customCurrencies);
        },
        moneyFromAmount: (amount, currency = "TWD")=>{
            return (0, $hgUW1$oddmoney).fromAmount(amount, currency, customCurrencies);
        }
    };
};
var $ce0348ab86c375ce$export$2e2bcd8739ae039 = $ce0348ab86c375ce$export$549663b327b2b282;




const $3f201e57b8864085$export$92e5afcdc0d187b6 = ()=>{
    const instance = (0, $194437a6ef3c58bb$export$f4a5c5dcfe1bba82)();
    const isMounted = (0, $hgUW1$ref)(false);
    (0, $hgUW1$onMounted)(()=>{
        // @ts-ignore
        instance.$nextTick(()=>isMounted.value = true);
    });
    return isMounted;
};



const $a4b23fb445f454ac$export$2cdec86ca467c001 = ()=>{
    let retry = 0;
    const { getItem: getItem , setItem: setItem , removeItem: removeItem  } = (0, $e769739f1cb29117$export$2e2bcd8739ae039)();
    const prevPageInfo1 = async ()=>await getItem("prevPage");
    const currentUrl = window.location.href;
    /**
   * private helper method.
   * find and scroll element into view, until meet retry limit.
   * @returns {Promise<void>}
   */ const __findElementAndScrollTo = async (params)=>{
        const element = document.querySelector(`#${params.prevPageInfo.leaveFrom}`);
        if (!element) {
            if (retry >= params.retryLimit) return retry = 0;
            setTimeout(()=>{
                retry += 1;
                __findElementAndScrollTo(params);
            }, 1000);
        } else {
            element.scrollIntoView({
                behavior: "smooth"
            });
            retry = 0;
            await removeItem("prevPage");
        }
    };
    return {
        /**
     * remember user leave from which point
     * @param {String} elementID HTML Element ID
     * @returns {Promise<void>}
     */ recordPrevPageInfo: async (elementID)=>{
            const prevPageInfo = {
                url: currentUrl,
                leaveFrom: elementID
            };
            await setItem("prevPage", prevPageInfo);
        },
        /**
     * fetch prevPageInfo from indexDB.
     * if current URL equal to prevPageInfo.url, find element by ID every 1 sec until meet retryLimit or element
     * found. if element found, smooth scroll it into view.
     * @param {number} retryLimit retry limit for find element and scroll to
     * @returns {Promise<void>}
     */ tryRestoreScrollPosition: async (retryLimit = 10)=>{
            const info = await prevPageInfo1();
            if (!info) return;
            if (info.url === currentUrl) await __findElementAndScrollTo({
                retryLimit: retryLimit,
                prevPageInfo: info
            });
        }
    };
};
var $a4b23fb445f454ac$export$2e2bcd8739ae039 = $a4b23fb445f454ac$export$2cdec86ca467c001;



const $8205d0a55fb32ba1$var$defaultParams = {
    message: "write something here please...",
    type: "is-success",
    position: "is-top",
    queue: false
};
const $8205d0a55fb32ba1$export$a407b657d3044108 = (paramsOptions = {})=>{
    (0, $hgUW1$ToastProgrammatic).open(Object.assign({}, $8205d0a55fb32ba1$var$defaultParams, paramsOptions));
};
var $8205d0a55fb32ba1$export$2e2bcd8739ae039 = $8205d0a55fb32ba1$export$a407b657d3044108;


const $3afe4631d93c52bc$export$c95b89df87ab6722 = (shareData, text)=>{
    const isShareSupported = window.navigator && "canShare" in window.navigator;
    const isCopySupported = navigator && "clipboard" in navigator;
    const isSupported = isShareSupported && isCopySupported;
    return {
        isShareSupported: isShareSupported,
        isCopySupported: isCopySupported,
        isSupported: isSupported,
        /**
     * share data or save text in clipboard on button clicked.
     */ clickHandler: async (event, toastParams = {
            message: "\u5DF2\u8907\u88FD\u5230\u526A\u8CBC\u7C3F",
            type: "is-info"
        }, disableCopy = false)=>{
            if (isShareSupported) await window.navigator.share(shareData);
            else {
                if (disableCopy) return;
                await navigator.clipboard.writeText(text);
                (0, $8205d0a55fb32ba1$export$2e2bcd8739ae039)(toastParams);
            }
        }
    };
};
var $3afe4631d93c52bc$export$2e2bcd8739ae039 = $3afe4631d93c52bc$export$c95b89df87ab6722;




const $ab5e68299c1c624d$var$defaultOptions = {
    effect: "fade",
    grabCursor: true,
    autoplay: {
        delay: 5000,
        disableOnInteraction: true
    },
    lazy: true,
    pagination: {
        el: ".swiper-pagination",
        clickable: true
    }
};
const $ab5e68299c1c624d$export$28a6094880e3e9fd = (options)=>{
    const swiperOptions = Object.assign({}, $ab5e68299c1c624d$var$defaultOptions, options);
    return {
        swiperOptions: swiperOptions
    };
};
var $ab5e68299c1c624d$export$2e2bcd8739ae039 = $ab5e68299c1c624d$export$28a6094880e3e9fd;




const $10f102be98e69c42$export$a801fa91fbaae349 = ()=>{
    const store = (0, $5c0dceef35680c1f$export$2e2bcd8739ae039)();
    return {
        setState: (key, value)=>{
            let newState = {};
            newState[key] = value;
            return store.dispatch("setTempState", newState);
        },
        getState: (key, defaultValue)=>{
            return (0, $hgUW1$computed)(()=>store.getters["tempState"](key) || defaultValue);
        },
        clearState: ()=>store.dispatch("clearTempState")
    };
};
var $10f102be98e69c42$export$2e2bcd8739ae039 = $10f102be98e69c42$export$a801fa91fbaae349;



const $129921d883a2be05$export$d0105baa5ed279b8 = (size = "500x500", searchTerm = "")=>{
    return `https://source.unsplash.com/random/${size}/?${searchTerm}&sig=${Math.floor(Math.random() * 100)}`;
};
var $129921d883a2be05$export$2e2bcd8739ae039 = $129921d883a2be05$export$d0105baa5ed279b8;




export {$b63295f3629e158d$export$5e0d2110ca6f99be as useCurrency, $86bbc49c94835efd$export$3901076af3749fa9 as useCurrentUser, $66800b516f8df6ed$export$87c0cf8eb5a167e0 as useForm, $878625f9e2aa6919$export$3f3caade1c12f8c9 as useI18n, $194437a6ef3c58bb$export$f4a5c5dcfe1bba82 as useInstance, $e769739f1cb29117$export$c28d9e613ce8016a as useLocalForage, $b5948fd5da0efdf8$export$33ffd74ebf07f060 as useModal, $048803914cb95fb8$export$128d2c11f5a1e7f3 as useModalOpener, $ce0348ab86c375ce$export$549663b327b2b282 as useMoney, $3f201e57b8864085$export$92e5afcdc0d187b6 as useMountedState, $a4b23fb445f454ac$export$2cdec86ca467c001 as useRestoreScrollPosition, $3afe4631d93c52bc$export$c95b89df87ab6722 as useShareButton, $5c0dceef35680c1f$export$6ccbb43953eebf8 as useStore, $ab5e68299c1c624d$export$28a6094880e3e9fd as useSwiper, $ab5e68299c1c624d$re_export$swiperSlide as swiperSlide, $ab5e68299c1c624d$re_export$swiper as swiper, $10f102be98e69c42$export$a801fa91fbaae349 as useTempState, $8205d0a55fb32ba1$export$a407b657d3044108 as useToast, $129921d883a2be05$export$d0105baa5ed279b8 as useUnsplash};
//# sourceMappingURL=module.js.map
